module.exports = __webpack_public_path__ + "img/clock-six.5cf353d0.svg";